import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import LocationSettings from 'components/Locations/Settings'

export const LocationSettingsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <LocationSettings />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
